export default "__VITE_ASSET__DXj0Xk9l__"